import { Input } from 'ui-components';

import { CONTACT_INFO_MAX_CHARACTERS } from './constants';
import { useMessageToolStore } from './useMessageToolStore';

export const ContactInfoStep = () => {
  const { creator } = useMessageToolStore();
  return (
    <div className="flex flex-col gap-6">
      <p>
        Please provide your contact details so {creator?.manager?.name} can
        respond to you directly. We'll also send you a copy of the message for
        your records.
      </p>

      <div className="flex flex-col gap-2">
        <Input
          name="name"
          label="Name"
          isRequired
          placeholder="Full Name"
          maxLength={CONTACT_INFO_MAX_CHARACTERS}
        />
        <Input
          name="email"
          label="Email"
          isRequired
          placeholder="Email address"
          maxLength={CONTACT_INFO_MAX_CHARACTERS}
        />
        <Input
          name="company"
          label="Company"
          isRequired
          placeholder="Company name"
          maxLength={CONTACT_INFO_MAX_CHARACTERS}
        />
      </div>
    </div>
  );
};
